module.exports = __webpack_public_path__ + "static/img/boxImg1.0c9133d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boxImg1.png
// module id = wPi2
// module chunks = 2